module.exports = __webpack_public_path__ + "99e013b971338b46af9613e1cd750e11.png";